import { APP_BASE_HREF, CommonModule, Location, ViewportScroller } from '@angular/common';
import { Component, effect, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ThemeService } from '@services/theme.service';
import { ApplicationStateFacade } from 'mbs-ui-shared/src/lib/facades/application.facade';
import { HelpService } from 'mbs-ui-shared@help/help.service';

@UntilDestroy()
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  host: {
    '(window:message)': 'message($event)'
  },
  imports: [CommonModule]
})
export class HelpComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private titleService = inject(Title);
  private location = inject(Location);
  private viewportScroll = inject(ViewportScroller);
  private appFacade = inject(ApplicationStateFacade);
  private helpService = inject(HelpService);
  private themeService = inject(ThemeService);

  frameUrl: SafeResourceUrl;
  baseHref: string;
  hasFooter = false;
  private iframeLoaded = false;

  @ViewChild('helpframe') helpFrame: ElementRef<HTMLIFrameElement>;

  constructor() {
    const href = inject(APP_BASE_HREF);

    this.baseHref = href;

    effect(() => {
      const theme = this.themeService.isDark() ? 'dark' : 'light';
      if (!this.iframeLoaded) return;
      this.helpFrame?.nativeElement.contentWindow?.postMessage({ msg: 'mbs-theme', theme }, '*');
    });
  }

  ngOnInit() {
    const pageName = this.location.path(true).replace('/AP/Help', '');
    const helpLink = this.helpService.getHelpLink(pageName);
    const theme = this.themeService.isDark() ? 'dark' : 'light';
    const separator = helpLink.includes('?') ? '&' : '?';
    const urlWithTheme = `${helpLink}${separator}theme=${theme}`;

    this.frameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithTheme);

    this.appFacade.selectFooterExist$.pipe(untilDestroyed(this)).subscribe((value) => (this.hasFooter = value));
  }

  onFrameLoad(): void {
    this.iframeLoaded = true;
  }

  message(event: { data: { path?: string; title?: string; externalUrl?: string; anchorOffsetTop?: number } }): void {
    if (event.data.path) {
      this.location.replaceState(`/AP/Help/${event.data.path.slice(1)}`);
    }

    if (event.data.title) {
      this.titleService.setTitle(event.data.title);
    }

    if (event.data.externalUrl) {
      window.open(event.data.externalUrl, '_blank');
    }

    if (event.data.anchorOffsetTop) {
      this.viewportScroll.scrollToPosition([0, event.data.anchorOffsetTop]);
    }
  }
}
